import * as THREE from 'three';

export default class MouseController {
  constructor(experience) {
    this.experience = experience;
    this.sizes = this.experience.sizes;
    this.camera = this.experience.camera;
    this.scene = this.experience.scene;

    this.target = { x: 0, y: 0 };
    this.current = { x: 0, y: 0 };
    this.normalized = new THREE.Vector2(0, 0);

    this.raycaster = new THREE.Raycaster();
    this.isHoveringCharacter = false;

    this.setupListeners();
  }

  setupListeners() {
    window.addEventListener('mousemove', (event) => {
      // Normalize to [-1, 1]
      this.target.x = (event.clientX / this.sizes.width) * 2 - 1;
      this.target.y = -(event.clientY / this.sizes.height) * 2 + 1;

      this.normalized.x = this.target.x;
      this.normalized.y = this.target.y;
    });

    window.addEventListener('touchstart', (event) => {
      if (event.touches.length > 0) {
        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
        this.target.x = (event.touches[0].clientX / this.sizes.width) * 2 - 1;
        this.target.y = -(event.touches[0].clientY / this.sizes.height) * 2 + 1;

        this.normalized.x = this.target.x;
        this.normalized.y = this.target.y;
      }
    }, { passive: true });

    window.addEventListener('touchmove', (event) => {
      if (event.touches.length > 0) {
        this.target.x = (event.touches[0].clientX / this.sizes.width) * 2 - 1;
        this.target.y = -(event.touches[0].clientY / this.sizes.height) * 2 + 1;

        this.normalized.x = this.target.x;
        this.normalized.y = this.target.y;
      }
    }, { passive: true });

    window.addEventListener('touchend', (event) => {
      // Tap detection: trigger jump/spin if touch was a quick tap
      if (event.changedTouches.length > 0 && this.touchStartX !== undefined) {
        const dx = Math.abs(event.changedTouches[0].clientX - this.touchStartX);
        const dy = Math.abs(event.changedTouches[0].clientY - this.touchStartY);
        if (dx < 20 && dy < 20) {
          const target = event.target;
          if (target && target.closest && target.closest('button, a, .switch-btn')) {
            return;
          }
          this.handleClick(true);
        }
      }
    });

    window.addEventListener('click', (event) => {
      if (event.target && event.target.closest && event.target.closest('button, a, .switch-btn')) {
        return;
      }
      this.handleClick(false);
    });
  }

  handleClick(isTouch = false) {
    if (!this.experience.world || !this.experience.world.character) return;

    this.raycaster.setFromCamera(this.normalized, this.camera.instance);
    const intersects = this.raycaster.intersectObjects(
      this.experience.world.character.interactiveMeshes,
      true
    );

    const isMobile = this.sizes.width < 768;
    if (intersects.length > 0 || this.isHoveringCharacter || (isTouch && isMobile)) {
      this.experience.world.character.triggerReaction();
    }
  }

  update() {
    // Smooth damping for mouse parallax (lerp factor 0.06)
    this.current.x += (this.target.x - this.current.x) * 0.06;
    this.current.y += (this.target.y - this.current.y) * 0.06;

    // Check hover state via raycasting
    if (this.experience.world && this.experience.world.character) {
      this.raycaster.setFromCamera(this.normalized, this.camera.instance);
      const intersects = this.raycaster.intersectObjects(
        this.experience.world.character.interactiveMeshes,
        true
      );

      const isHit = intersects.length > 0;
      if (isHit !== this.isHoveringCharacter) {
        this.isHoveringCharacter = isHit;
        document.body.style.cursor = isHit ? 'pointer' : 'default';
        this.experience.world.character.setHover(isHit);
      }
    }
  }
}
